import {styled, Box} from 'external/material'
import {centerVertically} from 'utils/style'
import Units from './Units'

const StyledUnits = styled(Box)(unitsStyles)

export default function UnitsPage() {
  return (
    <StyledUnits className="container">
      <Units />
    </StyledUnits>
  )
}

function unitsStyles() {
  return {
    "& .unitsWrapper": {
      flexGrow: 1,
      overflowY: 'auto',
      paddingBottom: 30,
      paddingRight: 11
    },
    "& .units": {
      flexGrow: 1,
    },
    "& .unit": {
      "&.expanded": {
        borderTop: 'solid 2px #dddddd'
      },
      textDecoration: 'none',
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: '#fff'
    },
    "& .unitSummary": {
      padding: '10px 20px',
      "&.expanded": {
        borderBottom: 'solid 1px #dddddd',
      },
      "& .unitName": {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        color: '#565f77',
        fontSize: '13.5pt',
        flexShrink: 1,
        "&.expanded": {
          fontWeight: 600
        }
      },
      "& .unitCountWrapper": {
        marginLeft: 15,
        "& .unitCount": {
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start'
        },
        display: 'flex',
        justifyContent: 'flex-end',
        flexGrow: 1,
        "& .count.lesson": {
          ...centerVertically,
          textAlign: 'center',
          fontSize: '11.5pt',
          width: 45,
          color: '#979797',
          border: 'solid 1px #979797',
          height: 22,
          borderRadius: 20,
          marginRight: 20,
          backgroundColor: '#fff',
          "&.expanded": {
            borderColor: '#ff47cb',
            color: '#fff',
            backgroundColor: '#ff47cb'
          }
        }
      }
    },
    "& .unitDetails": {
      backgroundColor: '#f6fbfe',
      padding: 0,
      paddingLeft: 25
    },
    "& .lessons": {
      "& .lesson": {
        borderBottom: 'solid 1px #e4e8eb',
        paddingRight: 25,
        "&:last-child": {
          borderBottom: 0
        },
        "& .lessonName": {
          "& span": {
            color: '#6b748c',
            fontSize: '13pt',
          },
          "&.scheduled": {
            "& span": {
              fontWeight: 600
            }
          }
        },
        "& .lessonIcon": {
          color: '#d6e3f1',
          "&.scheduled": {
            color: '#ff47cb'
          }
        },
        "& .lessonLinks": {
          display: 'flex',
          "& .lessonLink": {
            marginRight: 25
          }
        }
      }
    }
  }
}
